
import { NoticeProps} from "@/scripts/datatypes"
import { ClassData,PostStatus } from "../common-datatypes"
import { Component,Mixins} from "vue-property-decorator"
import { ValidationObserver,ValidationProvider } from 'vee-validate'
import Common from '@/mixins/common'
import ModalSelectUser from '@/components/ModalSelectUser.vue'
import { ValidationFlags } from "vee-validate/dist/types/types"
import TemplateMembers from '@/components/TemplateMembers.vue'

@Component({
  components: {
    ModalSelectUser,
    TemplateMembers
  }
})


export default class AddClass extends Mixins(Common) {
  notice = {} as NoticeProps
  disabledAddClass = true
  isActive = true
  defaultClassData: ClassData = {
    teacherUserIds: [],
    studentUserIds: [],
    name: '',
    description: '',
    memberUserIds: [],
    disabled: false,
    deleted: false,
    memberMeta: {},
    postStatus: 'draft'
  }
  tIsShow = false
  sIsShow = false
  theClass = {...this.defaultClassData}
  isLoading = false

  $refs!: {
    teachers: InstanceType<typeof ValidationProvider>;
    students: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  postStatuses(){
    if(this.$te('event.postStatus')){
      return this.$t('event.postStatus') as unknown as PostStatus
    }
    return undefined
  }

  get memberUserIds(){
    return Array.from(new Set([...this.theClass.teacherUserIds,...this.theClass.studentUserIds]))
  }

  async addClass(){
		try{
			this.notice = {
				isShow: false,
			}
		
      if(await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        let data: ClassData = {
          ...this.theClass,
          memberUserIds: this.memberUserIds
        }

        const classDocRef = await this.$createDoc(this.$getClassesColRef(),data)

        if(classDocRef){
          data = {
            ...data,
            ...classDocRef.data(),
            classId: classDocRef.id
          }
          this.$emit("onCreate", data)
        }

        
        this.notice = {
          message: this.$t('addClass.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
        
        this.theClass = {...this.defaultClassData}

        this.$nextTick(() =>{
          this.$refs.validationObserver.reset()
        })
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('addClass.error') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  created(){
    console.trace('created')
  }

  mounted(){
   console.log('mounted')
   this.$watch('$refs.validationObserver.flags',(flags: ValidationFlags) => {
    this.disabledAddClass = ! flags.changed
   })
  }

  onClose() {
    this.$emit("onClose", true)
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
